/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';

// @ts-expect-error: no types
import HubSpotLanguageSelect from 'ui-addon-i18n/components/HubSpotLanguageSelect';
import { getDefaultLang } from 'forms-utils-lib/language/getDefaultLang';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { getDefaultTranslatedFormName } from 'asset-actions-lib-forms/utils/langUtils';
import { getIsExternalEditor } from 'asset-actions-lib-forms/utils/urlUtils';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import FormCloningWarningWithFlows from 'asset-actions-lib-forms/clone/components/FormCloningWarningWithFlows';
import useCloneAndTranslateForm from 'asset-actions-lib-forms/createTranslation/hooks/useCloneAndTranslateForm';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MODAL_WIDTH = 540;
export default function TranslateFormDialog({
  crmObject,
  onClose,
  onConfirm,
  scopes
}) {
  const {
    onActionError
  } = useAssetActions();
  const {
    cloneAndTranslateForm,
    loading
  } = useCloneAndTranslateForm();
  const isExternalEditor = getIsExternalEditor();
  const hasBusinessUnitAccess = scopes.includes('business-units-access');
  const formType = String(crmObject ? getPropertyValue(crmObject, 'hs_form_type', '') : '');
  const formGuid = String(crmObject ? getPropertyValue(crmObject, 'hs_form_id', '') : '');
  const originalFormName = String(crmObject ? getPropertyValue(crmObject, 'hs_name', '') : '');
  const [language, setLanguage] = useState(getDefaultLang());
  const [formName, setFormName] = useState(getDefaultTranslatedFormName(originalFormName, language));
  const handleLanguageUpdate = useCallback(newLanguage => {
    setLanguage(newLanguage);
    setFormName(getDefaultTranslatedFormName(originalFormName, newLanguage));
  }, [originalFormName]);
  const handleCreateClick = useCallback(() => {
    return cloneAndTranslateForm({
      businessUnitId: undefined,
      formType: formType,
      guid: formGuid,
      name: formName
    }).then(publishedForm => {
      onClose();
      onConfirm(FORM_ACTION_IDS.CREATE_TRANSLATION, {
        publishedForm,
        language
      });
    }).catch(actionError => {
      if (onActionError) {
        onActionError({
          actionId: FORM_ACTION_IDS.CREATE_TRANSLATION,
          error: actionError
        });
      }
    });
  }, [cloneAndTranslateForm, formGuid, formName, formType, language, onActionError, onClose, onConfirm]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "form-create-translation-dialog",
    width: MODAL_WIDTH,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.translateDialog.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.translateDialog.langLabel"
        }),
        children: /*#__PURE__*/_jsx(HubSpotLanguageSelect, {
          "data-test-id": "language-select",
          useLanguageSetting: true,
          defaultValue: language,
          isPublic: true,
          onChange: ({
            language: newLanguage
          }) => {
            handleLanguageUpdate(newLanguage);
          }
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.translateDialog.nameLabel"
        }),
        children: /*#__PURE__*/_jsx(TextInput, {
          "data-test-id": "translate-dialog-form-name-input",
          value: formName,
          onChange: ({
            target: {
              value: newFormName
            }
          }) => setFormName(newFormName)
        })
      }), /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "600",
        children: /*#__PURE__*/_jsx(FormCloningWarningWithFlows, {
          formGuid: formGuid,
          formType: formType,
          hasBusinessUnitAccess: hasBusinessUnitAccess,
          isExternalEditor: isExternalEditor
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: handleCreateClick,
        disabled: loading,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.translateDialog.create"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "clone-form-cancel-button",
        use: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.translateDialog.cancelCta"
        })
      })]
    })]
  });
}